import React from "react";
import NewsletterFifteen from "../component/NewsletterFifteen";

function NewsletterFifteenContainer() {
  return <NewsletterFifteen />;
}

export default NewsletterFifteenContainer;
